<template>
	<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
		<!--input类型示例-->
		<FormItem prop="trackName">
			<FormItem prop="IP">
				<Input style="width: 260px;" type="text" v-model="formInline.Ip" placeholder="IP">
				<span slot="prepend">IP</span>
				</Input>
			</FormItem>
			<FormItem prop="Port">
				<Input style="width: 260px;" type="text" v-model="formInline.Port" :placeholder="$tt('端口')">
				<span slot="prepend">{{$tt('端口')}}</span>
				</Input>
			</FormItem>
			<FormItem prop="Path">
				<Input style="width: 260px;" type="text" v-model="formInline.Path" :placeholder="$tt('路径')">
				<span slot="prepend">{{$tt('路径')}}</span>
				</Input>
			</FormItem>
			<FormItem prop="UserName">
				<Input style="width: 260px;" type="text" v-model="formInline.UserName" :placeholder="$tt('用户名')">
				<span slot="prepend">{{$tt('用户名')}}</span>
				</Input>
			</FormItem>
			<FormItem prop="UserPwd">
				<Input style="width: 260px;" type="password" v-model="formInline.UserPwd" :placeholder="$tt('密码')">
				<span slot="prepend">{{$tt('密码')}}</span>
				</Input>
			</FormItem>
		</FormItem>
		<!-- 	<FormItem>
			<Button type="primary" @click="$emit('handleSubmit')">{{$tt('查询')}}</Button>
		</FormItem>
		<div style="float: right;">
			<Button type="primary" @click="$emit('show','add')">{{$tt('控件添加')}}</Button>
		</div> -->
	</Form>
</template>

<script>
	export default {
		//props: ['param', 'url'],
		data() {
			return {
				formInline: {
					Id: 1,
					Name: 'ftmName',
					Ip: '192.168.9.9',
					Port: '8021',
					Path: '/12/45',
					UserName: 'user',
					UserPwd: '123456',
					IsDefault: '1'
				},
			};
		},
		computed: {
			// pageParam: function() {
			// 	const _this = this;
			// 	const param = {
			// 		OperatorId: _this.formInline.OperatorId
			// 	}
			// 	return param
			// },
		},
		methods: {},
	}
</script>

<style>
</style>
